import {
  AppMode,
  DomTargeter,
  StorageStore,
  StorageType,
  charsParams,
  cookies,
  featureFlags,
  getContext,
  getFlags,
  require_cjs,
  version
} from "./chunk--chunk-GSFZ3OSC.vbt.js";
import {
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Abstract.js
var import_deepmerge2 = __toESM(require_cjs());

// node_modules/@searchspring/snap-client/dist/esm/Client/utils/fibonacci.js
var fibonacci = (num) => {
  let a = 1, b = 0, temp;
  while (num >= 0) {
    temp = a;
    a = a + b;
    b = temp;
    num--;
  }
  return b;
};

// node_modules/@searchspring/snap-client/dist/esm/Client/NetworkCache/NetworkCache.js
var import_deepmerge = __toESM(require_cjs());
var CACHE_STORAGE_KEY = "ss-networkcache";
var defaultConfig = {
  enabled: true,
  ttl: 3e5,
  maxSize: 200,
  purgeable: true
};
var NetworkCache = class {
  constructor(config) {
    this.memoryCache = {};
    this.config = (0, import_deepmerge.default)(defaultConfig, config || {});
    this.config?.entries && Object.keys(this.config.entries).map((key) => {
      if (this.config.entries && this.config.entries[key]) {
        this.set(key, this.config.entries[key]);
      }
    });
  }
  get(key) {
    if (this.config.enabled) {
      try {
        if (this.memoryCache[key]) {
          if (Date.now() < this.memoryCache[key].expires) {
            return (0, import_deepmerge.default)({}, this.memoryCache[key].value);
          }
        }
        const stored = sessionStorage.getItem(CACHE_STORAGE_KEY);
        const localData = stored && JSON.parse(stored);
        if (localData && key && localData[key]) {
          if (Date.now() >= localData[key].expires) {
            const newStored = {
              ...localData
            };
            delete newStored[key];
            sessionStorage.setItem(CACHE_STORAGE_KEY, JSON.stringify(newStored));
          } else {
            return localData[key].value;
          }
        }
      } catch (err) {
        console.warn("something went wrong, browser might not have cookies enabled");
      }
    }
  }
  set(key, value) {
    if (this.config.enabled) {
      try {
        const cacheObject = {
          value,
          expires: Date.now() + this.config.ttl,
          purgeable: this.config.purgeable
        };
        this.memoryCache[key] = cacheObject;
        const stored = sessionStorage.getItem(CACHE_STORAGE_KEY);
        const newStored = {
          ...stored && JSON.parse(stored)
        };
        newStored[key] = cacheObject;
        let size = new Blob([JSON.stringify(newStored)], { endings: "native" }).size / 1024;
        while (size > this.config.maxSize) {
          const oldestKey = Object.keys(newStored).filter((key2) => newStored[key2].purgeable).sort((a, b) => {
            return newStored[a].expires - newStored[b].expires;
          })[0];
          if (!oldestKey)
            break;
          delete newStored[oldestKey];
          size = new Blob([JSON.stringify(newStored)], { endings: "native" }).size / 1024;
        }
        if (size < this.config.maxSize) {
          sessionStorage.setItem(CACHE_STORAGE_KEY, JSON.stringify(newStored));
        }
      } catch (err) {
        console.warn("something went wrong, browser might not have cookies enabled");
      }
    }
  }
  clear() {
    try {
      this.memoryCache = {};
      sessionStorage.setItem(CACHE_STORAGE_KEY, "");
    } catch (err) {
      console.warn("something went wrong, browser might not have cookies enabled");
    }
  }
};

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Abstract.js
var isBlob = (value) => typeof Blob !== "undefined" && value instanceof Blob;
var API = class {
  constructor(configuration) {
    this.configuration = configuration;
    this.retryDelay = 1e3;
    this.retryCount = 0;
    this.cache = new NetworkCache(this.configuration.cache);
  }
  get mode() {
    return this.configuration.mode;
  }
  async request(context, cacheKey) {
    const { url, init } = this.createFetchParams(context);
    if (cacheKey) {
      const cachedResponse = this.cache.get(cacheKey);
      if (cachedResponse) {
        this.retryCount = 0;
        this.retryDelay = 1e3;
        return cachedResponse;
      }
    }
    let response;
    let responseJSON;
    try {
      response = await this.fetchApi(url, init);
      responseJSON = await response?.json();
      if (response.status >= 200 && response.status < 300) {
        this.retryCount = 0;
        this.retryDelay = 1e3;
        if (cacheKey) {
          this.cache.set(cacheKey, responseJSON);
        }
        return responseJSON;
      } else if (response.status == 429) {
        if (this.retryCount < this.configuration.maxRetry) {
          await new Promise((resolve) => setTimeout(resolve, this.retryDelay));
          this.retryDelay = fibonacci(this.retryCount) * 1e3;
          this.retryCount++;
          throw new Error("Rate limited.");
        } else {
          throw new Error("Retry rate limit exceeded.");
        }
      } else if (response.status == 404 && responseJSON?.message == "Profile is currently paused") {
        throw new Error(`${responseJSON.message}: ${context.query?.tag}`);
      }
      throw new Error("Unexpected Response Status.");
    } catch (err) {
      if (err.message == "Rate limited.") {
        return await this.request(context, cacheKey);
      }
      throw { err, fetchDetails: { status: response?.status, message: response?.statusText || "FAILED", url, ...init } };
    }
  }
  createFetchParams(context) {
    const siteId = context?.body?.siteId || context?.query?.siteId;
    if (!siteId) {
      throw new Error(`Request failed. Missing "siteId" parameter.`);
    }
    const siteIdHost = `https://${siteId}.a.searchspring.io`;
    const origin = (this.configuration.origin || siteIdHost).replace(/\/$/, "");
    let url = `${origin}/${context.path.replace(/^\//, "")}`;
    const combinedQuery = (0, import_deepmerge2.default)(context.query || {}, this.configuration.globals);
    if (Object.keys(combinedQuery).length !== 0) {
      url += "?" + this.configuration.queryParamsStringify(combinedQuery);
    }
    const body = typeof FormData !== "undefined" && context.body instanceof FormData || context.body instanceof URLSearchParams || isBlob(context.body) ? context.body : JSON.stringify(context.body ? (0, import_deepmerge2.default)(context.body, this.configuration.globals) : context.body);
    const headers = { ...this.configuration.headers, ...context.headers };
    const init = {
      method: context.method,
      headers,
      body
    };
    return { url, init };
  }
  async fetchApi(url, init) {
    const response = await this.configuration.fetchApi(url, init);
    return response;
  }
};
var ApiConfiguration = class {
  constructor(config = {}) {
    this.config = config;
    if (!config.maxRetry) {
      this.config.maxRetry = 8;
    }
    this.config.cache = this.config.cache || {};
    this.config.mode = this.config.mode || AppMode.production;
    if (this.config.mode == AppMode.development) {
      this.config.cache.enabled = false;
    }
  }
  get cache() {
    return this.config?.cache || {};
  }
  get maxRetry() {
    return this.config.maxRetry || 8;
  }
  get origin() {
    return this.config.origin || "";
  }
  get fetchApi() {
    return this.config.fetchApi || window.fetch.bind(window);
  }
  get queryParamsStringify() {
    return this.config.queryParamsStringify || querystring;
  }
  get headers() {
    return this.config.headers || {};
  }
  set headers(newHeaders) {
    this.config.headers = newHeaders;
  }
  get globals() {
    return this.config.globals || {};
  }
  set globals(newGlobals) {
    this.config.globals = newGlobals;
  }
  get mode() {
    return this.config.mode;
  }
};
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => {
    const fullKey = prefix + (prefix.length ? `[${key}]` : key);
    const value = params[key];
    if (value instanceof Array) {
      const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
      return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Date) {
      return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    }
    if (value instanceof Object) {
      return querystring(value, fullKey);
    }
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
  }).filter((part) => part.length > 0).join("&");
}

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Legacy.js
var LegacyAPI = class extends API {
  async getEndpoint(queryParameters, path = "/api/search/search.json") {
    queryParameters.resultsFormat = "native";
    const headerParameters = {};
    const cacheParameters = { ...queryParameters };
    delete cacheParameters.pageLoadId;
    const legacyResponse = await this.request({
      path,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, path + JSON.stringify(cacheParameters));
    return legacyResponse;
  }
  async postMeta(requestParameters) {
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: "/api/meta/meta.json",
      method: "POST",
      headers: headerParameters,
      body: requestParameters
    }, "/api/meta/meta.json" + JSON.stringify(requestParameters));
    return response;
  }
  async getMeta(queryParameters) {
    const headerParameters = {};
    const response = await this.request({
      path: "/api/meta/meta.json",
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, "/api/meta/meta.json" + JSON.stringify(queryParameters));
    return response;
  }
  async getSearch(queryParameters) {
    queryParameters.ajaxCatalog = "Snap";
    return this.getEndpoint(queryParameters, "/api/search/search.json");
  }
  async getAutocomplete(queryParameters) {
    queryParameters.ajaxCatalog = "Snap";
    return this.getEndpoint(queryParameters, "/api/search/autocomplete.json");
  }
  async getFinder(queryParameters) {
    queryParameters.ajaxCatalog = "Snap";
    return this.getEndpoint(queryParameters, "/api/search/finder.json");
  }
};

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Recommend.js
var Deferred = class {
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }
};
var BATCH_TIMEOUT = 150;
var RecommendAPI = class extends API {
  constructor(config) {
    super(config);
    this.batches = {};
  }
  async getProfile(queryParameters) {
    const headerParameters = {};
    const response = await this.request({
      path: "/api/personalized-recommendations/profile.json",
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, "/api/personalized-recommendations/profile.json" + JSON.stringify(queryParameters));
    return response;
  }
  async batchRecommendations(parameters) {
    const key = parameters.batched ? parameters.siteId : `${Math.random()}`;
    const batch = this.batches[key] = this.batches[key] || { timeout: null, request: { tags: [], limits: [] }, entries: [] };
    const deferred = new Deferred();
    batch.entries.push({ request: parameters, deferred });
    window.clearTimeout(batch.timeout);
    batch.timeout = window.setTimeout(async () => {
      delete this.batches[key];
      batch.entries.sort(sortBatchEntries);
      batch.entries.map((entry) => {
        const { tags, categories, ...otherParams } = entry.request;
        let limits = entry.request.limits;
        if (!limits) {
          limits = 20;
        }
        const [tag] = tags || [];
        delete otherParams.batched;
        delete otherParams.order;
        delete otherParams.limits;
        batch.request.tags.push(tag);
        if (categories) {
          if (!batch.request.categories) {
            batch.request.categories = Array.isArray(categories) ? categories : [categories];
          } else {
            batch.request.categories = batch.request.categories.concat(categories);
          }
        }
        batch.request.limits = batch.request.limits.concat(limits);
        batch.request = { ...batch.request, ...otherParams };
      });
      try {
        if (this.configuration.mode == AppMode.development) {
          batch.request.test = true;
        }
        let response;
        if (charsParams(batch.request) > 1024) {
          if (batch.request["product"]) {
            batch.request["product"] = batch.request["product"].toString();
          }
          response = await this.postRecommendations(batch.request);
        } else {
          response = await this.getRecommendations(batch.request);
        }
        batch.entries?.forEach((entry, index) => {
          entry.deferred.resolve([response[index]]);
        });
      } catch (err) {
        batch.entries?.forEach((entry) => {
          entry.deferred.reject(err);
        });
      }
    }, BATCH_TIMEOUT);
    return deferred.promise;
  }
  async getRecommendations(queryParameters) {
    const headerParameters = {};
    const siteId = queryParameters.siteId;
    const path = `/boost/${siteId}/recommend`;
    const response = await this.request({
      path,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, path + JSON.stringify(queryParameters));
    return response;
  }
  async postRecommendations(requestParameters) {
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const siteId = requestParameters.siteId;
    const path = `/boost/${siteId}/recommend`;
    const response = await this.request({
      path,
      method: "POST",
      headers: headerParameters,
      body: requestParameters
    }, path + JSON.stringify(requestParameters));
    return response;
  }
};
function sortBatchEntries(a, b) {
  if (a.request.order == void 0 && b.request.order == void 0) {
    return 0;
  }
  if (a.request.order == void 0 && b.request.order != void 0) {
    return 1;
  }
  if (b.request.order == void 0 && a.request.order != void 0) {
    return -1;
  }
  if (a.request.order < b.request.order) {
    return -1;
  }
  if (a.request.order > b.request.order) {
    return 1;
  }
  return 0;
}

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Suggest.js
var SuggestAPI = class extends API {
  async getSuggest(queryParameters) {
    const headerParameters = {};
    const response = await this.request({
      path: "/api/suggest/query",
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, "/api/suggest/query" + JSON.stringify(queryParameters));
    return response;
  }
  async postSuggest(requestParameters) {
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: "/api/suggest/query",
      method: "POST",
      headers: headerParameters,
      body: requestParameters
    }, "/api/suggest/query" + JSON.stringify(requestParameters));
    return response;
  }
  async getTrending(queryParameters) {
    const headerParameters = {};
    const response = await this.request({
      path: "/api/suggest/trending",
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, "/api/suggest/trending" + JSON.stringify(queryParameters));
    return response;
  }
  async postTrending(requestParameters) {
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: "/api/suggest/trending",
      method: "POST",
      headers: headerParameters,
      body: requestParameters
    }, "/api/suggest/trending" + JSON.stringify(requestParameters));
    return response;
  }
};

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Hybrid.js
var import_deepmerge3 = __toESM(require_cjs());

// node_modules/@searchspring/snap-client/dist/esm/Client/utils/mergeParams.js
function mergeParams(...args) {
  const ret = {};
  args.reverse().forEach((params) => {
    Object.keys(params).forEach((key) => {
      const values = params[key] instanceof Array ? params[key] : [params[key]];
      ret[key] = (ret[key] || []).concat(values);
    });
  });
  return ret;
}

// node_modules/@searchspring/snap-client/dist/esm/Client/transforms/searchRequest.js
function transformSearchRequest(request) {
  return mergeParams(transformSearchRequest.sorts(request), transformSearchRequest.search(request), transformSearchRequest.filters(request), transformSearchRequest.merchandising(request), transformSearchRequest.pagination(request), transformSearchRequest.siteId(request), transformSearchRequest.facets(request), transformSearchRequest.tracking(request), transformSearchRequest.personalization(request));
}
transformSearchRequest.sorts = (request = {}) => {
  return (request.sorts || []).reduce((acc, sort) => {
    if (!sort.field || !sort.direction || sort.direction != "asc" && sort.direction != "desc") {
      return acc;
    }
    return {
      ...acc,
      ["sort." + sort.field]: (acc[sort.field] || []).concat([sort.direction])
    };
  }, {});
};
transformSearchRequest.search = (request = {}) => {
  const reqSearch = request.search || {};
  const search = {};
  if (reqSearch.query && reqSearch.query.string) {
    search.q = reqSearch.query.string;
  }
  if (reqSearch.subQuery) {
    search.rq = reqSearch.subQuery.trim();
  }
  if (reqSearch.originalQuery) {
    search.originalQuery = reqSearch.originalQuery.trim();
  }
  if (reqSearch.fallbackQuery) {
    search.fallbackQuery = reqSearch.fallbackQuery.trim();
  }
  if (reqSearch.redirectResponse) {
    search.redirectResponse = reqSearch.redirectResponse;
  }
  return search;
};
transformSearchRequest.filters = (request = {}) => {
  return (request.filters || []).reduce((acc, filter) => {
    const baseKey = filter.background ? "bgfilter" : "filter";
    if (filter.type == "value") {
      const key = baseKey + "." + filter.field;
      return {
        ...acc,
        [key]: (acc[key] || []).concat([filter.value])
      };
    } else if (filter.type == "range") {
      const keyLow = baseKey + "." + filter.field + ".low";
      const keyHigh = baseKey + "." + filter.field + ".high";
      const low = filter?.value?.low ?? "*";
      const high = filter?.value?.high ?? "*";
      return {
        ...acc,
        [keyLow]: (acc[keyLow] || []).concat([low]),
        [keyHigh]: (acc[keyHigh] || []).concat([high])
      };
    }
    return acc;
  }, {});
};
transformSearchRequest.merchandising = (request = {}) => {
  const reqMerch = request.merchandising || {};
  const merch = reqMerch.disabled ? { disableMerchandising: true } : {};
  if (reqMerch.landingPage) {
    merch["landing-page"] = reqMerch.landingPage;
  }
  if (reqMerch.segments instanceof Array && reqMerch.segments.length) {
    merch["tag"] = reqMerch.segments.map((segment) => {
      return `merch.segment/${segment}`;
    });
  }
  if (typeof reqMerch.intellisuggest == "boolean") {
    merch["intellisuggest"] = reqMerch.intellisuggest;
  }
  if (reqMerch.disableInlineBanners) {
    merch["disableInlineBanners"] = reqMerch.disableInlineBanners;
  }
  return merch;
};
transformSearchRequest.pagination = (request = {}) => {
  const pagination = request.pagination || {};
  const params = {};
  if (pagination.page) {
    params.page = pagination.page;
  }
  if (pagination.pageSize || pagination.pageSize === 0) {
    params.resultsPerPage = pagination.pageSize;
  }
  return params;
};
transformSearchRequest.siteId = (request = {}) => {
  if (request.siteId) {
    return { siteId: request.siteId };
  }
  return {};
};
transformSearchRequest.facets = (request = {}) => {
  const facets = request.facets || {};
  const params = {};
  if (facets.include && facets.include.length && facets.exclude && facets.exclude.length) {
    throw "cannot use facet include and exclude at the same time";
  }
  if (facets.include?.length) {
    params.includedFacets = facets.include;
  }
  if (facets.exclude?.length) {
    params.excludedFacets = facets.exclude;
  }
  if (facets.autoDrillDown === false) {
    params.disableFacetDrillDown = true;
  }
  return params;
};
transformSearchRequest.tracking = (request = {}) => {
  const reqTracking = request.tracking || {};
  const params = {};
  if (reqTracking.userId) {
    params.userId = reqTracking.userId;
  }
  if (reqTracking.domain) {
    params.domain = reqTracking.domain;
  }
  if (reqTracking.sessionId) {
    params.sessionId = reqTracking.sessionId;
  }
  if (reqTracking.pageLoadId) {
    params.pageLoadId = reqTracking.pageLoadId;
  }
  return params;
};
transformSearchRequest.personalization = (request = {}) => {
  const personalization = request.personalization || {};
  const params = {};
  if (personalization.disabled) {
    params.skipPersonalization = personalization.disabled;
  }
  if (personalization.cart) {
    params.cart = personalization.cart;
  }
  if (personalization.lastViewed) {
    params.lastViewed = personalization.lastViewed;
  }
  if (personalization.shopper) {
    params.shopper = personalization.shopper;
  }
  return params;
};

// node_modules/@searchspring/snap-client/dist/esm/Client/utils/htmlUnescape.js
function htmlUnescape(value) {
  return value.replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&#0?39;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&");
}

// node_modules/@searchspring/snap-client/dist/esm/Client/transforms/searchResponse.js
var CORE_FIELDS = [
  "uid",
  "sku",
  "name",
  "url",
  "addToCartUrl",
  "price",
  "msrp",
  "imageUrl",
  "secureImageUrl",
  "thumbnailImageUrl",
  "secureThumbnailImageUrl",
  "rating",
  "ratingCount",
  "description",
  "stockMessage",
  "brand",
  "popularity",
  "caption"
];
var Result = class {
  constructor(result) {
    Object.assign(this, result);
  }
};
function transformSearchResponse(response, request) {
  return {
    ...transformSearchResponse.pagination(response),
    ...transformSearchResponse.results(response),
    ...transformSearchResponse.filters(response),
    ...transformSearchResponse.facets(response, request),
    ...transformSearchResponse.sorting(response),
    ...transformSearchResponse.merchandising(response),
    ...transformSearchResponse.search(response, request)
  };
}
transformSearchResponse.pagination = (response) => {
  const pagination = response?.pagination;
  return {
    pagination: {
      totalResults: pagination?.totalResults,
      page: pagination?.currentPage,
      pageSize: pagination?.perPage,
      totalPages: pagination?.totalPages
    }
  };
};
transformSearchResponse.results = (response) => {
  const results = response?.results || [];
  return { results: results.map(transformSearchResponse.result) };
};
transformSearchResponse.result = (rawResult) => {
  const coreFieldValues = CORE_FIELDS.reduce((coreFields, key) => {
    if (typeof rawResult[key] != "undefined") {
      return {
        ...coreFields,
        [key]: decodeProperty(rawResult[key] || "")
      };
    }
    return coreFields;
  }, {});
  if (coreFieldValues.price)
    coreFieldValues.price = +coreFieldValues.price;
  if (coreFieldValues.msrp)
    coreFieldValues.msrp = +coreFieldValues.msrp;
  const attributes = Object.keys(rawResult).filter((k) => CORE_FIELDS.indexOf(k) == -1).reduce((attributes2, key) => {
    return {
      ...attributes2,
      [key]: decodeProperty(rawResult[key] || "")
    };
  }, {});
  const children = rawResult?.children?.map((child) => {
    return {
      attributes: {
        ...Object.keys(child).reduce((attributes2, key) => {
          return {
            ...attributes2,
            [key]: decodeProperty(child[key])
          };
        }, {})
      }
    };
  }) || [];
  return new Result({
    id: rawResult.uid,
    mappings: {
      core: coreFieldValues
    },
    attributes,
    children
  });
};
transformSearchResponse.filters = (response) => {
  const filterSummary = response?.filterSummary || [];
  return {
    filters: filterSummary.map((filter) => {
      let value = filter.value;
      let type = "value";
      if (typeof filter.value == "object") {
        if (filter && filter.value && filter.value.rangeHigh && filter.value.rangeLow) {
          type = "range", value = {
            low: +filter.value.rangeLow,
            high: +filter.value.rangeHigh
          };
        }
      }
      return {
        type,
        field: filter.field,
        label: filter.filterValue,
        value
      };
    })
  };
};
transformSearchResponse.facets = (response, request = {}) => {
  const filters = request.filters || [];
  const facets = response?.facets || [];
  return {
    facets: facets.map((facet) => {
      let transformedFacet = {
        field: facet.field,
        type: "value",
        filtered: Boolean(facet.facet_active)
      };
      if (facet.step) {
        if (facet.range) {
          transformedFacet = {
            ...transformedFacet,
            type: "range",
            step: facet.step,
            range: {
              // TODO: change to null
              low: facet.range[0] == "*" ? void 0 : +facet.range[0],
              high: facet.range[1] == "*" ? void 0 : +facet.range[1]
            }
          };
        }
        if (facet.active && typeof facet.active != "boolean" && facet.active.length > 1) {
          transformedFacet.active = {
            // TODO: change to null
            low: facet.active[0] == "*" ? void 0 : +facet.active[0],
            high: facet.active[1] == "*" ? void 0 : +facet.active[1]
          };
        }
      } else if (facet.values instanceof Array) {
        if (facet.type == "hierarchy") {
          transformedFacet.type = "value";
          transformedFacet.values = (facet.values || []).map((value) => {
            return {
              filtered: Boolean(value.active),
              value: value.value,
              label: value.label,
              count: value.count
            };
          });
          const filterSelected = filters.find((f) => f.field == facet.field);
          const newValues = [];
          if (filterSelected && !filterSelected.background) {
            const valueLevels = filterSelected.value?.split(facet.hierarchyDelimiter || ">");
            if (valueLevels) {
              for (let i = valueLevels.length - 1; i >= 0; i--) {
                const valueSplit = valueLevels.slice(0, i + 1);
                const value = valueSplit.join(facet.hierarchyDelimiter);
                newValues.unshift({
                  value,
                  filtered: value == filterSelected.value,
                  label: valueSplit[valueSplit.length - 1]
                });
              }
            }
            newValues.unshift({
              value: null,
              filtered: false,
              label: "View All"
            });
          }
          transformedFacet.values = newValues.concat(transformedFacet.values);
        } else if (facet.values[0].type == "value") {
          transformedFacet.type = "value";
          transformedFacet.values = facet.values.map((value) => {
            return {
              filtered: value.active,
              value: value.value,
              label: value.label,
              count: value.count
            };
          });
        } else if (facet.values[0].type == "range") {
          transformedFacet.type = "range-buckets";
          transformedFacet.values = facet.values.map((value) => {
            return {
              filtered: value.active,
              low: value.low == "*" ? null : value.low ? +value.low : null,
              high: value.high == "*" ? null : value.high ? +value.high : null,
              label: value.label,
              count: value.count
            };
          });
        }
      }
      return transformedFacet;
    })
  };
};
transformSearchResponse.sorting = (response) => {
  const sorts = response?.sorting?.options || [];
  const transformedSorting = sorts.filter((sort) => sort.active).map((sort) => {
    return {
      field: sort.field,
      direction: sort.direction
    };
  });
  return {
    sorting: transformedSorting
  };
};
transformSearchResponse.merchandising = (response) => {
  const merchandising = response?.merchandising;
  if (merchandising.content && Array.isArray(merchandising.content) && !merchandising.content.length) {
    merchandising.content = {};
  }
  const transformedMerchandising = {
    redirect: merchandising?.redirect || "",
    content: merchandising.content || {},
    campaigns: merchandising?.triggeredCampaigns || [],
    personalized: merchandising?.personalized
  };
  return {
    merchandising: transformedMerchandising
  };
};
transformSearchResponse.search = (response, request) => {
  const searchObj = {
    search: {
      query: request?.search?.query?.string,
      didYouMean: response?.didYouMean?.query,
      matchType: response?.query?.matchType
    }
  };
  if (response?.query?.corrected && response?.query.original) {
    searchObj.search.query = response?.query?.corrected;
    searchObj.search.originalQuery = response?.query?.original;
  } else if (request?.search?.originalQuery) {
    searchObj.search.originalQuery = request?.search?.originalQuery;
  }
  return searchObj;
};
function decodeProperty(encoded) {
  if (Array.isArray(encoded)) {
    return encoded.map((item) => htmlUnescape(String(item)));
  } else {
    return htmlUnescape(String(encoded));
  }
}

// node_modules/@searchspring/snap-client/dist/esm/Client/transforms/suggestResponse.js
function transformSuggestResponse(response) {
  return {
    ...transformSuggestResponse.query(response),
    ...transformSuggestResponse.correctedQuery(response),
    ...transformSuggestResponse.suggested(response),
    ...transformSuggestResponse.alternatives(response)
  };
}
transformSuggestResponse.query = (response) => {
  if (!response?.query) {
    return {};
  }
  return { query: response.query };
};
transformSuggestResponse.correctedQuery = (response) => {
  if (typeof response != "object" || !response["corrected-query"]) {
    return {};
  }
  return { correctedQuery: response["corrected-query"] };
};
transformSuggestResponse.suggested = (response) => {
  if (typeof response != "object" || !response.suggested || typeof response.suggested != "object") {
    return {};
  }
  return {
    suggested: {
      text: response.suggested?.text,
      type: response.suggested?.type,
      source: response.suggested?.source
    }
  };
};
transformSuggestResponse.alternatives = (response) => {
  const alternatives = response?.alternatives || [];
  return {
    alternatives: alternatives.map((alternative) => {
      return {
        text: alternative.text
      };
    })
  };
};

// node_modules/@searchspring/snap-client/dist/esm/Client/apis/Hybrid.js
var HybridAPI = class extends API {
  constructor(configuration, requesterConfigurations) {
    super(configuration);
    const legacyConfig = (0, import_deepmerge3.default)({
      mode: configuration.mode,
      origin: configuration.origin,
      cache: this.configuration.cache
    }, requesterConfigurations?.legacy || {});
    if (configuration.mode == AppMode.development) {
      legacyConfig.headers = { ...legacyConfig.headers, "searchspring-no-beacon": "" };
    }
    const suggestConfig = (0, import_deepmerge3.default)({
      mode: configuration.mode,
      origin: configuration.origin,
      cache: this.configuration.cache
    }, requesterConfigurations?.suggest || {});
    const legacyConfiguration = new ApiConfiguration(legacyConfig);
    const suggestConfiguration = new ApiConfiguration(suggestConfig);
    this.requesters = {
      legacy: new LegacyAPI(legacyConfiguration),
      suggest: new SuggestAPI(suggestConfiguration)
    };
  }
  async getMeta(requestParameters) {
    const legacyRequestParameters = requestParameters;
    return this.requesters.legacy.getMeta(legacyRequestParameters);
  }
  async getSearch(requestParameters) {
    const legacyRequestParameters = transformSearchRequest(requestParameters);
    const legacyData = await this.requesters.legacy.getSearch(legacyRequestParameters);
    return transformSearchResponse(legacyData, requestParameters);
  }
  async getFinder(requestParameters) {
    const legacyRequestParameters = transformSearchRequest(requestParameters);
    const legacyData = await this.requesters.legacy.getFinder(legacyRequestParameters);
    return transformSearchResponse(legacyData, requestParameters);
  }
  async getAutocomplete(requestParameters) {
    const legacyRequestParameters = transformSearchRequest(requestParameters);
    const suggestParams = {
      siteId: legacyRequestParameters.siteId,
      language: "en",
      query: legacyRequestParameters.q,
      suggestionCount: (requestParameters.suggestions || {}).count || 5
    };
    if (!((requestParameters.search || {}).query || {}).spellCorrection) {
      suggestParams.disableSpellCorrect = true;
    }
    const suggestResults = await this.requesters.suggest.getSuggest(suggestParams);
    const transformedSuggestResults = transformSuggestResponse(suggestResults);
    let q = (transformedSuggestResults.suggested || {}).text || transformedSuggestResults.correctedQuery || transformedSuggestResults.query;
    if (this.requesters.suggest.configuration?.globals?.integratedSpellCorrection) {
      q = (transformedSuggestResults.suggested || {}).text || transformedSuggestResults.query || transformedSuggestResults.correctedQuery;
    }
    const queryParameters = {
      ...legacyRequestParameters,
      redirectResponse: "full",
      q
    };
    if (requestParameters.search?.query?.string) {
      requestParameters.search.query.string = q;
    }
    const legacyResults = await this.requesters.legacy.getAutocomplete(queryParameters);
    const searchResults = transformSearchResponse(legacyResults, requestParameters);
    return {
      ...searchResults,
      autocomplete: transformedSuggestResults
    };
  }
};

// node_modules/@searchspring/snap-client/dist/esm/Client/Client.js
var import_deepmerge4 = __toESM(require_cjs());
var defaultConfig2 = {
  mode: AppMode.production,
  meta: {
    cache: {
      purgeable: false
    }
  },
  search: {
    // origin: 'https://snapi.kube.searchspring.io'
  },
  autocomplete: {
    // origin: 'https://snapi.kube.searchspring.io'
  },
  recommend: {
    // origin: 'https://snapi.kube.searchspring.io'
  },
  finder: {
    // origin: 'https://snapi.kube.searchspring.io'
  },
  suggest: {
    // origin: 'https://snapi.kube.searchspring.io'
  }
};
var Client = class {
  constructor(globals, config = {}) {
    this.mode = AppMode.production;
    if (!globals?.siteId) {
      throw "no siteId specified!";
    }
    this.globals = globals;
    this.config = (0, import_deepmerge4.default)(defaultConfig2, config);
    if (Object.values(AppMode).includes(this.config.mode)) {
      this.mode = this.config.mode;
    }
    this.requesters = {
      autocomplete: new HybridAPI(new ApiConfiguration({
        mode: this.mode,
        origin: this.config.autocomplete?.origin,
        headers: this.config.autocomplete?.headers,
        cache: this.config.autocomplete?.cache,
        globals: this.config.autocomplete?.globals
      }), this.config.autocomplete?.requesters),
      meta: new HybridAPI(new ApiConfiguration({
        mode: this.mode,
        origin: this.config.meta?.origin,
        headers: this.config.meta?.headers,
        cache: this.config.meta?.cache,
        globals: this.config.meta?.globals
      })),
      recommend: new RecommendAPI(new ApiConfiguration({
        mode: this.mode,
        origin: this.config.recommend?.origin,
        headers: this.config.recommend?.headers,
        cache: this.config.recommend?.cache,
        globals: this.config.recommend?.globals
      })),
      search: new HybridAPI(new ApiConfiguration({
        mode: this.mode,
        origin: this.config.search?.origin,
        headers: this.config.search?.headers,
        cache: this.config.search?.cache,
        globals: this.config.search?.globals
      })),
      finder: new HybridAPI(new ApiConfiguration({
        mode: this.mode,
        origin: this.config.finder?.origin,
        headers: this.config.finder?.headers,
        cache: this.config.finder?.cache,
        globals: this.config.finder?.globals
      })),
      suggest: new SuggestAPI(new ApiConfiguration({
        mode: this.mode,
        origin: this.config.suggest?.origin,
        headers: this.config.suggest?.headers,
        cache: this.config.suggest?.cache,
        globals: this.config.suggest?.globals
      }))
    };
  }
  async meta(params) {
    const defaultParams = { siteId: this.globals.siteId };
    params = (0, import_deepmerge4.default)(defaultParams, params || {});
    return this.requesters.meta.getMeta(params);
  }
  async autocomplete(params = {}) {
    if (!params.search?.query?.string) {
      throw "query string parameter is required";
    }
    params = (0, import_deepmerge4.default)(this.globals, params);
    return Promise.all([this.meta({ siteId: params.siteId || "" }), this.requesters.autocomplete.getAutocomplete(params)]);
  }
  async search(params = {}) {
    params = (0, import_deepmerge4.default)(this.globals, params);
    return Promise.all([this.meta({ siteId: params.siteId || "" }), this.requesters.search.getSearch(params)]);
  }
  async finder(params = {}) {
    params = (0, import_deepmerge4.default)(this.globals, params);
    return Promise.all([this.meta({ siteId: params.siteId || "" }), this.requesters.finder.getFinder(params)]);
  }
  async trending(params) {
    params = (0, import_deepmerge4.default)({ siteId: this.globals.siteId }, params || {});
    return this.requesters.suggest.getTrending(params);
  }
  async recommend(params) {
    const { tag, ...otherParams } = params;
    if (!tag) {
      throw "tag parameter is required";
    }
    const profileParams = {
      tag,
      siteId: params.siteId || this.globals.siteId
    };
    if (otherParams.branch) {
      profileParams.branch = otherParams.branch;
      delete otherParams.branch;
    }
    const recommendParams = {
      tags: [tag],
      ...otherParams,
      siteId: params.siteId || this.globals.siteId
    };
    const [profile, recommendations] = await Promise.all([
      this.requesters.recommend.getProfile(profileParams),
      this.requesters.recommend.batchRecommendations(recommendParams)
    ]);
    return {
      ...profile,
      results: recommendations[0].results
    };
  }
};

// node_modules/@searchspring/snap-logger/dist/esm/colors.js
var colors = {
  blue: "#3379c1",
  bluelight: "#688BA3",
  bluedark: "#1B3141",
  bluegreen: "#318495",
  grey: "#61717B",
  green: "#507B43",
  greendark: "#63715F",
  greenblue: "#46927D",
  indigo: "#4c3ce2",
  orange: "#ecaa15",
  orangelight: "#ff6600",
  orangedark: "#c59600",
  red: "#cc1212",
  redlight: "#f30707",
  reddark: "#8E111C",
  yellow: "#d1d432"
};

// node_modules/@searchspring/snap-logger/dist/esm/emoji.js
var emoji = {
  bang: String.fromCodePoint(8252),
  bright: String.fromCodePoint(128262),
  check: String.fromCodePoint(10004),
  clock: String.fromCodePoint(128342),
  cloud: String.fromCodePoint(9729),
  dim: String.fromCodePoint(128261),
  gear: String.fromCodePoint(9881),
  interobang: String.fromCodePoint(8265),
  lightning: String.fromCodePoint(9889),
  magic: String.fromCodePoint(10024),
  rocket: String.fromCodePoint(128640),
  search: String.fromCodePoint(128269),
  snap: String.fromCodePoint(128165),
  ufo: String.fromCodePoint(128760),
  vortex: String.fromCodePoint(127744),
  warning: String.fromCodePoint(9888)
};

// node_modules/@searchspring/snap-logger/dist/esm/Logger.js
var Logger = class {
  constructor(config) {
    this.mode = AppMode.production;
    this.emoji = emoji;
    this.colors = colors;
    this.prefix = "";
    this.prefix = config?.prefix || "";
    this.mode = config?.mode || AppMode.production;
  }
  setNamespace(group) {
    this.prefix = ` [${group}] :: `;
  }
  error(...params) {
    let text = "";
    let rest = params;
    if (params.length && typeof params[0] == "string") {
      [text, ...rest] = params;
    }
    console.log(`%c ${emoji.bang} %c${this.prefix}${text}`, `color: ${colors.red}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${colors.red}; font-weight: bold;`, ...rest);
  }
  warn(...params) {
    let text = "";
    let rest = params;
    if (params.length && typeof params[0] == "string") {
      [text, ...rest] = params;
    }
    console.log(`%c ${emoji.warning} %c${this.prefix}%c${text}`, `color: ${colors.yellow}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${colors.yellow}; font-weight: normal;`, `color: ${colors.yellow}; font-weight: bold;`, ...rest);
  }
  image({ url, width, height }, ...params) {
    const styles = {
      size: `font-size: 1px; padding: ${height || width} ${width || height};`,
      background: `background: url("${url}") no-repeat; background-size: contain;`
    };
    this.dev(`%c...`, `${styles.size} ${styles.background}`, ...params);
  }
  imageText({ url, text = "", style }, ...params) {
    const styles = {
      background: `margin-left: 6px; background: url("${url}") no-repeat; background-size: contain;`,
      custom: style
    };
    let imgText = text;
    let rest = params;
    if (!imgText && params?.length) {
      [imgText, ...rest] = params;
    }
    this.dev(`%c ${"  " + this.prefix}${imgText}`, `${styles.background} ${styles.custom}`, ...rest);
  }
  debug(...params) {
    let text = "";
    let rest = params;
    if (params.length && typeof params[0] == "string") {
      [text, ...rest] = params;
    }
    this.dev(`%c ${emoji.interobang} %c${this.prefix}${text}`, `color: ${colors.orangelight}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${colors.orangelight}; font-weight: bold;`, ...rest);
  }
  profile(profile, ...params) {
    this.dev(`%c ${emoji.gear} %c${this.prefix}%c${profile.type}  %c~  ${profile.name}  ::  %c${profile.status.toUpperCase()}${profile.status == "finished" ? "  ::  %c" + profile.time.run + "ms" : ""}`, `color: ${colors.orange}; font-size: 14px; line-height: 12px;`, `color: ${colors.orange};`, `color: ${colors.orange}; font-style: italic;`, `color: ${colors.orange};`, `color: ${colors.orange}; font-weight: bold;`, `color: ${colors.grey};`, ...params);
  }
  dev(...params) {
    if (this.mode === AppMode.development) {
      console.log(...params);
    }
  }
};

// node_modules/@searchspring/snap-tracker/dist/esm/Tracker.js
var import_deepmerge5 = __toESM(require_cjs());

// node_modules/uuid/dist/esm-browser/rng.js
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}

// node_modules/uuid/dist/esm-browser/regex.js
var regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

// node_modules/uuid/dist/esm-browser/validate.js
function validate(uuid) {
  return typeof uuid === "string" && regex_default.test(uuid);
}
var validate_default = validate;

// node_modules/uuid/dist/esm-browser/stringify.js
var byteToHex = [];
for (i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).substr(1));
}
var i;
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate_default(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var stringify_default = stringify;

// node_modules/uuid/dist/esm-browser/v4.js
function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }
    return buf;
  }
  return stringify_default(rnds);
}
var v4_default = v4;

// node_modules/@searchspring/snap-tracker/dist/esm/TrackEvent.js
var TrackEvent = class {
  constructor(payload) {
    payload.event = payload.event;
    if (!payload.context || !payload.event) {
      throw "TrackEvent: object parameter required a valid `context` BeaconContext and `event` ProductClickEvent objects";
    }
    if (!payload.event?.intellisuggestData || !payload.event?.intellisuggestSignature) {
      throw "TrackEvent: object parameter `event` ProductClickEvent object requires valid intellisuggestData and intellisuggestSignature values. These are the corresponding attributes in the Searchspring API response.";
    }
    this.intellisuggestData = payload.event.intellisuggestData;
    this.intellisuggestSignature = payload.event.intellisuggestSignature;
    this.href = payload.event?.href || "";
    this.endpoint = `https://${payload.context.website.trackingCode}.a.searchspring.io/api/track/track.json`;
    this.src = this.endpoint + `?d=${encodeURIComponent(this.intellisuggestData)}&s=${encodeURIComponent(this.intellisuggestSignature)}&u=${encodeURIComponent(this.href || "")}`;
    if (window.document.referrer) {
      this.src += `&r=${encodeURIComponent(window.document.referrer)}`;
    }
    this.img = new Image(1, 1);
    this.img.src = this.src;
  }
};

// node_modules/@searchspring/snap-tracker/dist/esm/types.js
var BeaconType;
(function(BeaconType2) {
  BeaconType2["PRODUCT"] = "product";
  BeaconType2["CART"] = "cart";
  BeaconType2["ORDER"] = "transaction";
  BeaconType2["LOGIN"] = "login";
  BeaconType2["CLICK"] = "click";
  BeaconType2["ERROR"] = "error";
  BeaconType2["CUSTOM"] = "custom";
  BeaconType2["PROFILE_RENDER"] = "profile.render";
  BeaconType2["PROFILE_IMPRESSION"] = "profile.impression";
  BeaconType2["PROFILE_CLICK"] = "profile.click";
  BeaconType2["PROFILE_PRODUCT_RENDER"] = "profile.product.render";
  BeaconType2["PROFILE_PRODUCT_IMPRESSION"] = "profile.product.impression";
  BeaconType2["PROFILE_PRODUCT_CLICK"] = "profile.product.click";
})(BeaconType || (BeaconType = {}));
var BeaconCategory;
(function(BeaconCategory2) {
  BeaconCategory2["PAGEVIEW"] = "searchspring.page.view";
  BeaconCategory2["CARTVIEW"] = "searchspring.shop.cart";
  BeaconCategory2["ORDERVIEW"] = "searchspring.shop.transaction";
  BeaconCategory2["PERSONALIZATION"] = "searchspring.personalization";
  BeaconCategory2["RECOMMENDATIONS"] = "searchspring.recommendations.user-interactions";
  BeaconCategory2["INTERACTION"] = "searchspring.user-interactions";
  BeaconCategory2["RUNTIME"] = "searchspring.js.runtime";
  BeaconCategory2["CUSTOM"] = "custom";
})(BeaconCategory || (BeaconCategory = {}));
var ProfilePlacement;
(function(ProfilePlacement2) {
  ProfilePlacement2["BASKETPAGE"] = "basket-page";
  ProfilePlacement2["CONFIRMATIONPAGE"] = "confirmation-page";
  ProfilePlacement2["PRODUCTPAGE"] = "product-page";
  ProfilePlacement2["NORESULTSPAGE"] = "no-results-page";
  ProfilePlacement2["HOMEPAGE"] = "home-page";
  ProfilePlacement2["OTHER"] = "other";
})(ProfilePlacement || (ProfilePlacement = {}));

// node_modules/@searchspring/snap-tracker/dist/esm/PixelEvent.js
var PixelEvent = class {
  constructor(payload) {
    this.endpoint = `https://d3cgm8py10hi0z.cloudfront.net/is.gif`;
    this.src = this.endpoint + `?s=${encodeURIComponent(payload?.context?.website?.trackingCode || "")}&u=${encodeURIComponent(payload?.context?.userId || "")}&ce=${featureFlags.cookies ? "1" : "0"}&pt=${encodeURIComponent(document.title)}&v=1&x=${Math.floor(Math.random() * 2147483647)}${window.document.referrer ? `&r=${encodeURIComponent(window.document.referrer)}` : ""}`;
    switch (payload.category) {
      case BeaconCategory.PAGEVIEW:
        this.event = payload.event;
        this.src += "&a=viewItem";
        if (this.event.sku) {
          this.src += `&sku=${encodeURIComponent(this.event.sku)}`;
        }
        break;
      case BeaconCategory.CARTVIEW:
        this.event = payload.event;
        this.src += "&a=basket";
        this.event.items.forEach((item) => {
          if (item?.sku) {
            this.src += `&item=${encodeURIComponent(item.sku)};${encodeURIComponent(item?.qty || "")};${encodeURIComponent(item?.price || "")};`;
          }
        });
        break;
      case BeaconCategory.ORDERVIEW:
        const { orderId, total, city, state, country, items } = this.event = payload.event;
        this.src += `&a=sale`;
        if (orderId)
          this.src += `&orderId=${encodeURIComponent(orderId)}`;
        if (total)
          this.src += `&total=${encodeURIComponent(total)}`;
        if (city)
          this.src += `&city=${encodeURIComponent(city)}`;
        if (state)
          this.src += `&state=${encodeURIComponent(state)}`;
        if (country)
          this.src += `&country=${encodeURIComponent(country)}`;
        items.forEach((item) => {
          if (item?.sku) {
            this.src += `&item=${encodeURIComponent(item.sku)};${encodeURIComponent(item?.qty || "")};${encodeURIComponent(item?.price || "")};`;
          }
        });
        break;
    }
    if (this.src.includes("&a=")) {
      this.img = new Image(1, 1);
      this.img.src = this.src;
    }
  }
};

// node_modules/@searchspring/snap-tracker/dist/esm/BeaconEvent.js
var BeaconEvent = class {
  constructor(payload, config) {
    this.type = payload.type;
    this.category = payload.category;
    this.context = payload.context;
    this.meta = payload.meta;
    this.event = payload.event;
    this.id = payload.id;
    this.pid = payload.pid;
    this.meta = {
      initiator: {
        lib: "searchspring/snap",
        "lib.version": version,
        "lib.framework": config.framework
      }
    };
    this.id = v4_default();
  }
};

// node_modules/@searchspring/snap-tracker/dist/esm/Tracker.js
var BATCH_TIMEOUT2 = 200;
var LEGACY_USERID_COOKIE_NAME = "_isuid";
var USERID_COOKIE_NAME = "ssUserId";
var SHOPPERID_COOKIE_NAME = "ssShopperId";
var COOKIE_EXPIRATION = 31536e6;
var VIEWED_COOKIE_EXPIRATION = 220752e6;
var COOKIE_SAMESITE = "Lax";
var SESSIONID_STORAGE_NAME = "ssSessionIdNamespace";
var LOCALSTORAGE_BEACON_POOL_NAME = "ssBeaconPool";
var CART_PRODUCTS = "ssCartProducts";
var VIEWED_PRODUCTS = "ssViewedProducts";
var MAX_VIEWED_COUNT = 20;
var MAX_PARENT_LEVELS = 3;
var defaultConfig3 = {
  id: "track",
  framework: "snap",
  mode: AppMode.production
};
var Tracker = class {
  constructor(globals, config) {
    this.mode = AppMode.production;
    this.targeters = [];
    this.track = {
      event: (payload) => {
        const event = {
          type: payload?.type || BeaconType.CUSTOM,
          category: payload?.category || BeaconCategory.CUSTOM,
          context: payload?.context ? (0, import_deepmerge5.default)(this.context, payload.context) : this.context,
          event: payload.event,
          pid: payload?.pid || void 0
        };
        const beaconEvent = new BeaconEvent(event, this.config);
        this.sendEvents([beaconEvent]);
        return beaconEvent;
      },
      error: (data, siteId) => {
        if (!data?.stack && !data?.message) {
          return;
        }
        let context = this.context;
        if (siteId) {
          context = (0, import_deepmerge5.default)(context, {
            context: {
              website: {
                trackingCode: siteId
              }
            }
          });
        }
        const { href, filename, stack, message, colno, lineno, errortimestamp, details } = data;
        const payload = {
          type: BeaconType.ERROR,
          category: BeaconCategory.RUNTIME,
          context,
          event: {
            href: href || window.location.href,
            filename,
            stack,
            message,
            colno,
            lineno,
            errortimestamp,
            details,
            context: data.context
          }
        };
        if (payload.event.message?.includes("Profile is currently paused") || !payload.event.href || payload.event.href.includes("//localhost") || payload.event.href.includes("//snapui.searchspring.io/")) {
          return;
        }
        return this.track.event(payload);
      },
      shopper: {
        login: (data, siteId) => {
          if (!getFlags().cookies()) {
            return;
          }
          if (!data.id) {
            console.error('tracker.shopper.login event: requires a valid shopper ID parameter. Example: tracker.shopper.login({ id: "1234" })');
            return;
          }
          data.id = `${data.id}`;
          let context = this.context;
          if (siteId) {
            context = (0, import_deepmerge5.default)(context, {
              context: {
                website: {
                  trackingCode: siteId
                }
              }
            });
            context.shopperId = data.id;
          }
          const storedShopperId = this.getShopperId();
          if (storedShopperId != data.id) {
            cookies.set(SHOPPERID_COOKIE_NAME, data.id, COOKIE_SAMESITE, COOKIE_EXPIRATION);
            this.context.shopperId = data.id;
            this.sendPreflight();
            const payload = {
              type: BeaconType.LOGIN,
              category: BeaconCategory.PERSONALIZATION,
              context,
              event: {
                userId: this.context.userId,
                shopperId: data.id
              }
            };
            return this.track.event(payload);
          }
        }
      },
      product: {
        view: (data, siteId) => {
          if (!data?.sku && !data?.childSku) {
            console.error('track.product.view event: requires a valid sku and/or childSku. \nExample: track.product.view({ sku: "product123", childSku: "product123_a" })');
            return;
          }
          let context = this.context;
          if (siteId) {
            context = (0, import_deepmerge5.default)(context, {
              context: {
                website: {
                  trackingCode: siteId
                }
              }
            });
          }
          const payload = {
            type: BeaconType.PRODUCT,
            category: BeaconCategory.PAGEVIEW,
            context,
            event: {
              sku: data?.sku ? `${data.sku}` : void 0,
              childSku: data?.childSku ? `${data.childSku}` : void 0
            }
          };
          const sku = data?.sku || data?.childSku;
          if (sku) {
            const lastViewedProducts = this.cookies.viewed.get();
            const uniqueCartItems = Array.from(/* @__PURE__ */ new Set([...lastViewedProducts, sku])).map((item) => item.trim());
            cookies.set(VIEWED_PRODUCTS, uniqueCartItems.slice(0, MAX_VIEWED_COUNT).join(","), COOKIE_SAMESITE, VIEWED_COOKIE_EXPIRATION);
            if (!lastViewedProducts.includes(sku)) {
              this.sendPreflight();
            }
          }
          if (data?.sku) {
            new PixelEvent({
              ...payload,
              event: {
                sku: data.sku
              }
            });
          }
          return this.track.event(payload);
        },
        click: (data, siteId) => {
          if (!data?.intellisuggestData || !data?.intellisuggestSignature) {
            console.error(`track.product.click event: object parameter requires a valid intellisuggestData and intellisuggestSignature. 
Example: track.click.product({ intellisuggestData: "eJwrTs4tNM9jYCjKTM8oYXDWdQ3TDTfUDbIwMDVjMARCYwMQSi_KTAEA9IQKWA", intellisuggestSignature: "9e46f9fd3253c267fefc298704e39084a6f8b8e47abefdee57277996b77d8e70" })`);
            return;
          }
          let context = this.context;
          if (siteId) {
            context = (0, import_deepmerge5.default)(context, {
              context: {
                website: {
                  trackingCode: siteId
                }
              }
            });
          }
          const payload = {
            type: BeaconType.CLICK,
            category: BeaconCategory.INTERACTION,
            context,
            event: {
              intellisuggestData: data.intellisuggestData,
              intellisuggestSignature: data.intellisuggestSignature,
              href: data?.href ? `${data.href}` : void 0
            }
          };
          new TrackEvent(payload);
          return this.track.event(payload);
        }
      },
      cart: {
        view: (data, siteId) => {
          if (!Array.isArray(data?.items) || !data?.items.length) {
            console.error('track.view.cart event: parameter must be an array of cart items. \nExample: track.view.cart({ items: [{ sku: "product123", childSku: "product123_a", qty: "1", price: "9.99" }] })');
            return;
          }
          let context = this.context;
          if (siteId) {
            context = (0, import_deepmerge5.default)(context, {
              context: {
                website: {
                  trackingCode: siteId
                }
              }
            });
          }
          const items = data.items.map((item, index) => {
            if (!item?.qty || !item?.price || !item?.sku && !item?.childSku) {
              console.error(`track.view.cart event: item ${item} at index ${index} requires a valid qty, price, and (sku and/or childSku.) 
Example: track.view.cart({ items: [{ sku: "product123", childSku: "product123_a", qty: "1", price: "9.99" }] })`);
              return;
            }
            const product = {
              qty: `${item.qty}`,
              price: `${item.price}`
            };
            if (item?.sku) {
              product.sku = `${item.sku}`;
            }
            if (item?.childSku) {
              product.childSku = `${item.childSku}`;
            }
            return product;
          });
          const payload = {
            type: BeaconType.CART,
            category: BeaconCategory.CARTVIEW,
            context,
            event: { items }
          };
          if (items.length) {
            const products = items.map((item) => item?.sku || item?.childSku || "").filter((sku) => sku);
            this.cookies.cart.add(products);
          }
          new PixelEvent(payload);
          return this.track.event(payload);
        }
      },
      order: {
        transaction: (data, siteId) => {
          if (!data?.items || !Array.isArray(data.items) || !data.items.length) {
            console.error('track.order.transaction event: object parameter must contain `items` array of cart items. \nExample: order.transaction({ order: { id: "1001", total: "9.99", city: "Los Angeles", state: "CA", country: "US" }, items: [{ sku: "product123", childSku: "product123_a", qty: "1", price: "9.99" }] })');
            return;
          }
          let context = this.context;
          if (siteId) {
            context = (0, import_deepmerge5.default)(context, {
              context: {
                website: {
                  trackingCode: siteId
                }
              }
            });
          }
          const items = data.items.map((item, index) => {
            if (!item?.qty || !item?.price || !item?.sku && !item?.childSku) {
              console.error(`track.order.transaction event: object parameter \`items\`: item ${item} at index ${index} requires a valid qty, price, and (sku and/or childSku.) 
Example: order.view({ items: [{ sku: "product123", childSku: "product123_a", qty: "1", price: "9.99" }] })`);
              return;
            }
            const product = {
              qty: `${item.qty}`,
              price: `${item.price}`
            };
            if (item?.sku) {
              product.sku = `${item.sku}`;
            }
            if (item?.childSku) {
              product.childSku = `${item.childSku}`;
            }
            return product;
          });
          const eventPayload = {
            orderId: data?.order?.id ? `${data.order.id}` : void 0,
            total: data?.order?.total ? `${data.order.total}` : void 0,
            city: data?.order?.city ? `${data.order.city}` : void 0,
            state: data?.order?.state ? `${data.order.state}` : void 0,
            country: data?.order?.country ? `${data.order.country}` : void 0,
            items
          };
          const payload = {
            type: BeaconType.ORDER,
            category: BeaconCategory.ORDERVIEW,
            context,
            event: eventPayload
          };
          this.cookies.cart.clear();
          new PixelEvent(payload);
          return this.track.event(payload);
        }
      }
    };
    this.updateContext = (key, value) => {
      if (value) {
        this.context[key] = value;
      }
    };
    this.getUserId = () => {
      let userId;
      try {
        if (getFlags().cookies()) {
          userId = cookies.get(LEGACY_USERID_COOKIE_NAME) || cookies.get(USERID_COOKIE_NAME) || v4_default();
          cookies.set(USERID_COOKIE_NAME, userId, COOKIE_SAMESITE, COOKIE_EXPIRATION);
          cookies.set(LEGACY_USERID_COOKIE_NAME, userId, COOKIE_SAMESITE, COOKIE_EXPIRATION);
        } else if (getFlags().storage()) {
          userId = window.localStorage.getItem(USERID_COOKIE_NAME) || v4_default();
          window.localStorage.setItem(USERID_COOKIE_NAME, userId);
        } else {
          throw "unsupported features";
        }
      } catch (e) {
        console.error("Failed to persist user id to cookie or local storage:", e);
      }
      return userId;
    };
    this.getSessionId = () => {
      let sessionId;
      if (getFlags().storage()) {
        try {
          sessionId = window.sessionStorage.getItem(SESSIONID_STORAGE_NAME) || v4_default();
          window.sessionStorage.setItem(SESSIONID_STORAGE_NAME, sessionId);
          getFlags().cookies() && cookies.set(SESSIONID_STORAGE_NAME, sessionId, COOKIE_SAMESITE, 0);
        } catch (e) {
          console.error("Failed to persist session id to session storage:", e);
        }
      } else if (getFlags().cookies()) {
        sessionId = cookies.get(SESSIONID_STORAGE_NAME);
        if (!sessionId) {
          sessionId = v4_default();
          cookies.set(SESSIONID_STORAGE_NAME, sessionId, COOKIE_SAMESITE, 0);
        }
      }
      return sessionId;
    };
    this.getShopperId = () => {
      const shopperId = cookies.get(SHOPPERID_COOKIE_NAME);
      if (!shopperId) {
        return;
      }
      return shopperId;
    };
    this.sendPreflight = () => {
      const userId = this.getUserId();
      const siteId = this.context.website.trackingCode;
      const shopper = this.getShopperId();
      const cart = this.cookies.cart.get();
      const lastViewed = this.cookies.viewed.get();
      if (userId && typeof userId == "string" && siteId && (shopper || cart.length || lastViewed.length)) {
        const preflightParams = {
          userId,
          siteId
        };
        let queryStringParams = `?userId=${encodeURIComponent(userId)}&siteId=${encodeURIComponent(siteId)}`;
        if (shopper) {
          preflightParams.shopper = shopper;
          queryStringParams += `&shopper=${encodeURIComponent(shopper)}`;
        }
        if (cart.length) {
          preflightParams.cart = cart;
          queryStringParams += cart.map((item) => `&cart=${encodeURIComponent(item)}`).join("");
        }
        if (lastViewed.length) {
          preflightParams.lastViewed = lastViewed;
          queryStringParams += lastViewed.map((item) => `&lastViewed=${encodeURIComponent(item)}`).join("");
        }
        const origin = this.config.requesters?.personalization?.origin || `https://${siteId}.a.searchspring.io`;
        const endpoint = `${origin}/api/personalization/preflightCache`;
        const xhr = new XMLHttpRequest();
        if (charsParams(preflightParams) > 1024) {
          xhr.open("POST", endpoint);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(JSON.stringify(preflightParams));
        } else {
          xhr.open("GET", endpoint + queryStringParams);
          xhr.send();
        }
      }
    };
    this.cookies = {
      cart: {
        get: () => {
          const items = cookies.get(CART_PRODUCTS);
          if (!items) {
            return [];
          }
          return items.split(",");
        },
        set: (items) => {
          if (items.length) {
            const cartItems = items.map((item) => item.trim());
            const uniqueCartItems = Array.from(new Set(cartItems));
            cookies.set(CART_PRODUCTS, uniqueCartItems.join(","), COOKIE_SAMESITE, 0);
            const itemsHaveChanged = cartItems.filter((item) => items.includes(item)).length !== items.length;
            if (itemsHaveChanged) {
              this.sendPreflight();
            }
          }
        },
        add: (items) => {
          if (items.length) {
            const currentCartItems = this.cookies.cart.get();
            const itemsToAdd = items.map((item) => item.trim());
            const uniqueCartItems = Array.from(/* @__PURE__ */ new Set([...currentCartItems, ...itemsToAdd]));
            cookies.set(CART_PRODUCTS, uniqueCartItems.join(","), COOKIE_SAMESITE, 0);
            const itemsHaveChanged = currentCartItems.filter((item) => itemsToAdd.includes(item)).length !== itemsToAdd.length;
            if (itemsHaveChanged) {
              this.sendPreflight();
            }
          }
        },
        remove: (items) => {
          if (items.length) {
            const currentCartItems = this.cookies.cart.get();
            const itemsToRemove = items.map((item) => item.trim());
            const updatedItems = currentCartItems.filter((item) => !itemsToRemove.includes(item));
            cookies.set(CART_PRODUCTS, updatedItems.join(","), COOKIE_SAMESITE, 0);
            const itemsHaveChanged = currentCartItems.length !== updatedItems.length;
            if (itemsHaveChanged) {
              this.sendPreflight();
            }
          }
        },
        clear: () => {
          if (this.cookies.cart.get().length) {
            cookies.unset(CART_PRODUCTS);
            this.sendPreflight();
          }
        }
      },
      viewed: {
        get: () => {
          const items = cookies.get(VIEWED_PRODUCTS);
          if (!items) {
            return [];
          }
          return items.split(",");
        }
      }
    };
    this.sendEvents = (eventsToSend) => {
      if (this.mode !== AppMode.production) {
        return;
      }
      const savedEvents = JSON.parse(this.localStorage.get(LOCALSTORAGE_BEACON_POOL_NAME) || "[]");
      if (eventsToSend) {
        const eventsClone = [];
        savedEvents.forEach((_event, idx) => {
          eventsClone.push(Object.assign({}, _event));
          delete eventsClone[idx].id;
          delete eventsClone[idx].pid;
        });
        const stringyEventsClone = JSON.stringify(eventsClone);
        eventsToSend.forEach((event, idx) => {
          const newEvent = Object.assign({}, event);
          delete newEvent.id;
          delete newEvent.pid;
          if (stringyEventsClone.indexOf(JSON.stringify(newEvent)) == -1) {
            savedEvents.push({ ...eventsToSend[idx] });
          }
        });
        this.localStorage.set(LOCALSTORAGE_BEACON_POOL_NAME, JSON.stringify(savedEvents));
      }
      clearTimeout(this.isSending);
      this.isSending = window.setTimeout(() => {
        if (savedEvents.length) {
          const xhr = new XMLHttpRequest();
          const origin = this.config.requesters?.beacon?.origin || "https://beacon.searchspring.io";
          xhr.open("POST", `${origin}/beacon`);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(JSON.stringify(savedEvents.length == 1 ? savedEvents[0] : savedEvents));
        }
        this.localStorage.set(LOCALSTORAGE_BEACON_POOL_NAME, JSON.stringify([]));
      }, BATCH_TIMEOUT2);
    };
    if (typeof globals != "object" || typeof globals.siteId != "string") {
      throw new Error(`Invalid config passed to tracker. The "siteId" attribute must be provided.`);
    }
    this.config = (0, import_deepmerge5.default)(defaultConfig3, config || {});
    if (Object.values(AppMode).includes(this.config.mode)) {
      this.mode = this.config.mode;
    }
    this.globals = globals;
    this.localStorage = new StorageStore({
      type: StorageType.LOCAL,
      key: `ss-${this.config.id}-${this.globals.siteId}-local`
    });
    this.context = {
      userId: this.getUserId() || "",
      sessionId: this.getSessionId(),
      shopperId: this.getShopperId(),
      pageLoadId: v4_default(),
      website: {
        trackingCode: this.globals.siteId
      }
    };
    if (!window.searchspring?.tracker) {
      window.searchspring = window.searchspring || {};
      window.searchspring.tracker = this;
      window.searchspring.version = version;
    }
    setTimeout(() => {
      this.targeters.push(new DomTargeter([{ selector: 'script[type^="searchspring/track/"]', emptyTarget: false }], (target, elem) => {
        const { item, items, siteId, shopper, order, type } = getContext(["item", "items", "siteId", "shopper", "order", "type"], elem);
        switch (type) {
          case "searchspring/track/shopper/login":
            this.track.shopper.login(shopper, siteId);
            break;
          case "searchspring/track/product/view":
            this.track.product.view(item, siteId);
            break;
          case "searchspring/track/cart/view":
            this.track.cart.view({ items }, siteId);
            break;
          case "searchspring/track/order/transaction":
            this.track.order.transaction({ order, items }, siteId);
            break;
          default:
            console.error(`event '${type}' is not supported`);
            break;
        }
      }));
    });
    document.addEventListener("click", (event) => {
      const updateRecsControllers = () => {
        if (window.searchspring.controller) {
          Object.keys(window.searchspring.controller).forEach((name) => {
            const controller = window.searchspring.controller[name];
            if (controller.type === "recommendation" && controller.config?.realtime) {
              controller.search();
            }
          });
        }
      };
      const getClickAttributes = (event2) => {
        const attributeList = [
          `ss-${this.config.id}-cart-add`,
          `ss-${this.config.id}-cart-remove`,
          `ss-${this.config.id}-cart-clear`,
          `ss-${this.config.id}-cart-view`,
          `ss-${this.config.id}-intellisuggest`,
          `ss-${this.config.id}-intellisuggest-signature`,
          `href`
        ];
        const attributes2 = {};
        let levels = 0;
        let elem = null;
        elem = event2 && event2.target;
        while (Object.keys(attributes2).length == 0 && elem !== null && levels <= MAX_PARENT_LEVELS) {
          Object.values(elem.attributes).forEach((attr) => {
            const attrName = attr.nodeName;
            if (attributeList.indexOf(attrName) != -1) {
              attributes2[attrName] = elem && elem.getAttribute(attrName);
            }
          });
          elem = elem.parentElement;
          levels++;
        }
        return attributes2;
      };
      const attributes = getClickAttributes(event);
      if (attributes[`ss-${this.config.id}-cart-add`]) {
        const skus = attributes[`ss-${this.config.id}-cart-add`].split(",");
        this.cookies.cart.add(skus);
        updateRecsControllers();
      } else if (attributes[`ss-${this.config.id}-cart-remove`]) {
        const skus = attributes[`ss-${this.config.id}-cart-remove`].split(",");
        this.cookies.cart.remove(skus);
        updateRecsControllers();
      } else if (`ss-${this.config.id}-cart-clear` in attributes) {
        this.cookies.cart.clear();
        updateRecsControllers();
      } else if (`ss-${this.config.id}-cart-view` in attributes) {
        updateRecsControllers();
      } else if (attributes[`ss-${this.config.id}-intellisuggest`] && attributes[`ss-${this.config.id}-intellisuggest-signature`]) {
        const intellisuggestData = attributes[`ss-${this.config.id}-intellisuggest`];
        const intellisuggestSignature = attributes[`ss-${this.config.id}-intellisuggest-signature`];
        const href = attributes["href"];
        this.track.product.click({
          intellisuggestData,
          intellisuggestSignature,
          href
        });
      }
    });
    this.sendEvents();
  }
  getGlobals() {
    return JSON.parse(JSON.stringify(this.globals));
  }
  getContext() {
    return JSON.parse(JSON.stringify(this.context));
  }
  retarget() {
    this.targeters.forEach((target) => {
      target.retarget();
    });
  }
};

export {
  Client,
  Logger,
  BeaconType,
  BeaconCategory,
  ProfilePlacement,
  Tracker
};
